/* Balkan — produse vizitate recent.
 *
 * Doua responsabilitati:
 *   1. pe orice pagina de produs, tine minte handle-ul in localStorage;
 *   2. in secțiunea balkan-pdp-recent, cere serverului cite un card pentru
 *      fiecare handle din istoric, prin Section Rendering API:
 *      `/products/<handle>?section_id=<ID-ul complet al sectiunii minicard>`.
 *
 * De ce prin server si nu construind carduri in JS: preturile si valutele sunt
 * formatate de Liquid. Orice formatare in JS ar produce „119,00 RON" acolo unde
 * restul magazinului scrie „119,00 lei".
 *
 * De ce nu prin `/search?section_id=…`, varianta obisnuita: API-ul randeaza o
 * secțiune numai daca ea exista in sablonul URL-ului cerut. Secțiunea e in
 * `product.json`, nu in sablonul de căutare, deci /search intoarce 404 —
 * verificat, nu presupus.
 *
 * Daca nu exista istoric, secțiunea rimine ascunsa — nu randam un raft gol.
 */
(function () {
  var KEY = 'bk:recent';
  var MAX = 16;

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  /* ---------------------------------------------------------- 1. inregistrare */
  var meta = document.querySelector('[data-bk-seen]');
  if (meta) {
    var h = meta.getAttribute('data-bk-seen');
    if (h) {
      var list = read().filter(function (x) { return x !== h; });
      list.unshift(h);
      write(list);
    }
  }

  /* ------------------------------------------------------------- 2. randare */
  document.querySelectorAll('[data-bk-recent]').forEach(function (root) {
    var exclude = root.getAttribute('data-exclude') || '';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
    /* ID-ul COMPLET al sectiunii, publicat de `balkan-pdp-minicard.liquid`.
       Cel scurt da 404 la sectiunile din sabloane JSON (M-02 din audit). */
    var holder = document.querySelector('[data-bk-minicard-id]');
    var cardId = root.getAttribute('data-card-section')
      || (holder && holder.getAttribute('data-bk-minicard-id'))
      || 'balkan_minicard';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var handles = read().filter(function (x) { return x && x !== exclude; }).slice(0, limit);
    if (!handles.length) return;

    /* o cerere per produs, maxim `limit`; fiecare raspuns e un singur card.
       Ordinea de afisare e cea a istoricului, nu cea in care raspund. */
    Promise.all(handles.map(function (handle) {
      var url = base + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(cardId);
      return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('[data-bk-minicard] .bk-mini');
        })
        .catch(function () { return null; });
    })).then(function (cards) {
      var target = root.querySelector('[data-bk-recent-list]');
      cards.forEach(function (li) { if (li) target.appendChild(li); });
      if (target.children.length) root.hidden = false;
    });
  });
})();
